'use client';

import { useRouter } from 'next/navigation';
import { ArticleTag } from '../../types';
import styles from './ArticleTagList.module.scss';

function ArticleTagList({ tags }: { tags: Array<ArticleTag> }) {
  const router = useRouter();
  const handleClick = (e: React.MouseEvent, tag: ArticleTag) => {
    e.preventDefault();
    router.push(`/informations?tag=${tag.id}`);
  };
  return (
    <ul className={styles.componentStyle}>
      {tags.map((tag, index) => (
        <li key={index}>
          <a
            className={styles.itemBlock}
            href='#'
            onClick={(e) => {
              handleClick(e, tag);
            }}
          >
            {tag.name}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default ArticleTagList;
